import React from 'react';
import { inject } from 'mobx-react';
import Product from '../../models/Product';
import Price from '../Price/Price';
import DiscountPercentage from '../Price/DiscountPercentage';
import FavouriteIcon from '../Favourite/FavouriteIcon';
import LocalizedLink from '../LocalizedLink';
import AuthenticationStore from '../../stores/Authentication';
import { SendEventForHits } from 'instantsearch.js/es/lib/utils';
import ProductBlockImages from './ProductBlockImages';
import QuickView from '../QuickView/QuickView';

interface Props {
  product: Product;
  authentication?: AuthenticationStore;
  slider?: boolean;
  isFocused?: boolean;
  sendEvent?: SendEventForHits;
}

@inject('authentication')
export default class ProductBlock extends React.Component<Props> {
  ref: HTMLElement;

  constructor(props) {
    super(props);

    this.ref = null;
  }

  componentDidMount() {
    this.scrollToThisProduct();
  }

  componentDidUpdate() {
    this.scrollToThisProduct();
  }

  scrollToThisProduct() {
    const { isFocused } = this.props;
    if (isFocused && this.ref) {
      // Timeout is required to work around render race conditions.
      // Probably can be resolved in some better way.
      setTimeout(() => {
        this.ref.scrollIntoView({
          block: 'center',
        });
      }, 100);
    }
  }

  public render() {
    const { product, sendEvent, authentication } = this.props;

    let urlQuery = ``;
    if (product?.data?.__queryID) {
      urlQuery = `?queryId=${product.data.__queryID}`;
    }

    const isAuthenticated = authentication?.loggedIn || false;

    return (
      <div
        className="mb-4"
        onClick={() => {
          if (sendEvent) {
            sendEvent('click', product.data, 'Product clicked');
          }
        }}
        ref={(ref) => {
          this.ref = ref;
        }}
      >
        <div className="relative">
          <LocalizedLink to={`/toode/${product.slug}${urlQuery}`}>
            <ProductBlockImages product={product} />
          </LocalizedLink>

          <div className="absolute top-3 right-3 flex flex-col-reverse md:flex-row gap-2">
            <QuickView productSlug={product.slug} urlQuery={urlQuery} />
            <FavouriteIcon
              productSlug={product.slug}
              componentClassName="rounded-full bg-rgrey-middle"
            />
          </div>

          <DiscountPercentage
            prices={product.prices(isAuthenticated)}
            productNew={product.isNew}
            componentClassName="absolute left-0 text-xs!"
            containerClassName="items-start pt-4 pl-3"
            hidePercentage={!isAuthenticated}
          />
        </div>
        <LocalizedLink to={`/toode/${product.slug}`}>
          <div className="pt-1">
            <span className="leading-4 text-black text-s">{product.title}</span>
          </div>
          <div className="font-axi-book text-s pt-1">
            <span className="capitalize">{product.brandTitle}</span>{' '}
            {product.gridTitle}
          </div>
          <div className="font-axi-bold text-base pt-1">
            <Price
              prices={product.prices(isAuthenticated)}
              discountPriceClassname="text-black mr-3"
            />
          </div>
        </LocalizedLink>
      </div>
    );
  }
}
